import { isPlayingFromBeginningVar } from '../../movie-player/utils/is-playing-from-beginning-var';
import { promoContentIdVar } from '../../movie-player/hooks/use-promo-content-id-var';
import { trailerStartPositionVar } from '../../movie-trailer-player/utils/trailer-start-position-var';

interface PlayingParams {
    trailerStartPosition?: number;
    isPlayingFromBeginning?: boolean;
    promoContentId?: string;
}

export const setPlayingParams = ({
    trailerStartPosition,
    isPlayingFromBeginning,
    promoContentId,
}: PlayingParams) => {
    if (isPlayingFromBeginning) {
        isPlayingFromBeginningVar.set(true);
    }
    if (trailerStartPosition) {
        trailerStartPositionVar.set(trailerStartPosition);
    }
    if (promoContentId) {
        promoContentIdVar.set(promoContentId);
    }
};
